import React from 'react';
import {FormattedMessage} from 'react-intl';
import Review from 'theme/assets/images/review.svg';

const ProjectInReview = () => {
  return (
    <div className="tc pv5">
      <img src={Review} height="60" width="60" alt="project review" />
      <h3 className="pv3">
        <FormattedMessage id="in_review" />
      </h3>
      <p className="pv3 pb6-ns">
        <FormattedMessage id="project_in_review_description" />
      </p>
    </div>
  );
};

export default ProjectInReview;
